import styled from "styled-components";
import { COLORS, FONT_SIZE, FONT_WEIGHT } from "../../constants/Styles";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;

  > button {
    width: 100%;
    margin-top: 1rem;
  }
`;

export const Success = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Description = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size18};
  font-weight: ${FONT_WEIGHT.weight400};
  margin: 1rem 0;
  text-align: center;
`;

export const FinePrint = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size12};
  font-weight: ${FONT_WEIGHT.weight200};
  margin-top: 1rem;
`;
